import { redirect } from 'react-router';
import { logout } from '@sonifi/wb-login/services/keyMaster.service';
import { setGroupByUrl } from '@sonifi/wb-group/services/group.service';
import { store } from '../store/store';
import { initApp } from '../services/store.service';

const onNoAuth = async ({ usesSSO }) => {
  await store.dispatch(logout({ usesSSO }));
  throw redirect('/');
};

const checkPermissions = ({ permissions, user, usesSSO }) => {
  if (
    !permissions ||
    user?.permissionsList?.some((pm) =>
      permissions.some((p) => p === pm.permission),
    )
  ) {
    return true;
  } else {
    onNoAuth({ usesSSO });
  }
};

async function checkAuthStatus(groupId) {
  const {
    application: { appLoaded },
  } = store.getState();

  if (!appLoaded) {
    await store.dispatch(initApp(groupId));
  } else if (groupId) {
    store.dispatch(setGroupByUrl(groupId));
  }

  const {
    user: { authenticated },
  } = store.getState();

  return authenticated;
}

export const loaderAuthHome = (loader) => async (args) => {
  await checkAuthStatus();
  return loader ? await loader(args) : null;
};

export const loaderAuthProduct = (loader) => async (args) => {
  await checkAuthStatus(args.params.groupId);
  return loader ? await loader(args) : null;
};

export const authGuard =
  ({ permissions }) =>
  async ({ params }, next) => {
    const authenticated = await checkAuthStatus(params.groupId);

    const {
      user: { user, usesSSO },
    } = store.getState();

    if (authenticated && checkPermissions({ permissions, user, usesSSO })) {
      return next();
    } else {
      return onNoAuth({ usesSSO });
    }
  };
